/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type ForcJournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";

interface Signature {
  Args: {
    forcComponent: ForcJournalEventBasedComponent;
    selectedTabButton: "first" | "second";
    onTabButtonClicked: () => "first" | "second";
    dfgDateLabel: string;
    racDateLabel: string;
  };
}

import templateOnly, { type TOC } from "@ember/component/template-only";
const KfreBaseEditionFormComponent: TOC<Signature> = templateOnly();
export default KfreBaseEditionFormComponent;
